export default __webpack_public_path__ + "static/media/04.63f2b4b6.jpg";